import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateEditAccount = document.createElement('template');

templateEditAccount.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>

    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>

    <div class='content-wrapper' id='edit-account'>
      <div class='form-wrapper'>

        <gz-account-details></gz-account-details>
        <gz-account-login-security></gz-account-login-security>
        <gz-account-role-and-privileges></gz-account-role-and-privileges>
        <gz-targets class='hidden'></gz-targets>

      </div>

      <div class='bottom-buttons'>
        <gz-button id='save-button' type='full' disabled></gz-button>
        <div class='flex-auto'></div>
        <gz-button color='secondary' type='outline' id='cancel-button' ></gz-button>
      </div>

    </div>
  </div>`;
